import React from 'react';

export interface ModeStyle04Props {
  value?: string;
  options: string[];
  disabled?: boolean;
  loading?: boolean;
  onChange: (value: string) => void;
  label?: string;
  labels?: Record<string, string>;
}

/**
 * Mode Style 04 - Pills
 * Horizontal pill-shaped buttons
 */
export const Style04_Pills: React.FC<ModeStyle04Props> = ({
  value,
  options,
  disabled = false,
  loading = false,
  onChange,
  label = '運轉模式',
  labels = { '1': '節能', '3': '標準', '5': '強力', '8': '連續' }
}) => {
  return (
    <div className="space-y-3">
      <span className="text-sm text-slate-300">{label}</span>
      <div className="flex gap-2">
        {options.map((option) => {
          const isSelected = value === option;
          return (
            <button
              key={option}
              onClick={() => onChange(option)}
              disabled={disabled || loading}
              className={`flex-1 py-2.5 px-3 rounded-full text-sm font-medium transition-all ${
                isSelected
                  ? 'bg-blue-500 text-white'
                  : 'bg-slate-700/50 text-slate-400 hover:bg-slate-600/50'
              } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              {loading && isSelected ? '...' : labels[option] || option}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Style04_Pills;
